import apiConfig from '../APIUtil/ApiConfig';
import CallApi from '../APIUtil/CallApi';

export const getMaintenanceConfig = (loading, onSuccess, onFailure) => {
  return CallApi(apiConfig.maintenance.getConfig, null, null, loading, onSuccess, onFailure);
};
